export const fmtINR = (n: number) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n);

export const fmtNumber = (n: number) =>
  new Intl.NumberFormat('en-IN').format(n);

export const fmtDate = (iso: string) => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};

export const fmtPct = (n: number) =>
  `${(n * 100).toFixed(1)}%`;
